import { showAlert, hideAlert } from '../redux/reducers/alert'

export default {
  data() {
    return this.mapState({ alert: 'alert' })
  },
  beforeCreate() {
    this.mapDispatch({ showAlert, hideAlert })
  }
}
